import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import Day         from '@common/calender/day';
// -------------------------------------------------------

class Week extends React.Component {
  /*
   * 設定の変更
   */
  getWeekData() {
    let ary = [];
    
    this.props.week.map((day) => {
      this.props.schedule.map((tmp, key) => {
        let d = Object.assign({}, tmp);
        if( d.start_date == null && d.end_date == null ) return null;
        
        if( d.start_date == null ) d.start_date = d.end_date;
        if( d.end_date == null ) d.end_date = d.start_date;
        
        d.st_diff = Moment(d.start_date).diff( Moment(day), 'day');
        d.ed_diff = Moment(d.end_date).diff( Moment(day), 'day');
        
        //console.log(day +' == '+ Utils.setDate(d.start_date) +':'+ d.st_diff +'='+ Utils.setDate(d.end_date) +':'+ d.ed_diff);
        if( d.st_diff <= 0 && d.ed_diff >= 0 ){
          d.is_action = true;
        }
        
        if( d.insta_id == undefined ){
          d.mode = 'dashboard';
          d.work_data = Const.value.schedule_works[d.act];
        } else {
          d.mode = 'workflow';
          d.work_data = Const.value.schedule_workflow[d.act];
        }
        
        d.unique_key = (d.project_id +'_'+ d.act);
        d.day = day;
        ary.push(d);
        
      });
    });
    return ary;
  }
  // -------------------------------------------------------
  
  render() {
    let week     = this.props.week;
    let date     = this.props.date;
    //let mode     = this.props.mode;
    let schedule = this.props.schedule;
    
    let action_list = {};
    let weekList = this.getWeekData.bind(this)();
    weekList.map((d) => { if( d.is_action == true ) action_list[d.unique_key] = true; });
    
    let weekly_works = [];
    week.map((day) => {
      let works = [];
      
      weekList.map((d, key) => {
        if( d.day != day ) return;
        
        if( d.st_diff > 0 || d.ed_diff < 0 ){
          if( action_list[d.unique_key] === true ) works.push({ space: true });
          return;
        }
        
        let type = (d.st_diff == 0) ? 'st' : '';
        if( d.ed_diff == 0 ) type = (type == 'st') ? 'st_ed' : 'ed';
        if( type == '' ) type = 'middle';
        
        works.push(Object.assign({ type: type, mode: d.mode, diff: Moment(d.end_date).diff( Moment(d.start_date), 'day') }, d));
      });
      if( works.length > 0 ) works.push({ space: true });
      
      weekly_works.push(works);
    });
    
    return (
      <div className="week">
        { week.map((day, key) => {
          return <Day key={key} no={key} day={day} date={date} works={weekly_works[key]} />;
        })}
      </div>
    )
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Week;